export default (name, index = false) => () =>
  import(`components/${name}${index ? "/index" : ""}.vue`);



// WEBPACK FOOTER //
// ./src/store/modules/menu/lazyLoading.js